import { createStyles, Theme } from "@material-ui/core";

export const ContactsStyles = (theme: Theme) => createStyles({
    root: {}
})